import {
  Box,
  Button,
  Card,
  CardHeader,
  styled,
  Typography,
} from '@mui/material';
import { useNavigate } from '@tanstack/react-router';
import NoData from 'icons/NoData.icon';
import { title } from 'process';
import { useEffect, useState } from 'react';

const StyledCard = styled(Card)(() => ({
  borderRadius: '12px',
  background: '#FFFFFF',
  border: '1px solid var(--Light-Gray)',
  padding: '20px',
  boxShadow: '0px 1px 2px 0px #0205111A',
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}));

const StyledQuestionButton = styled(Button)(() => ({
  padding: '6px 14px',
  borderRadius: '8px',
  background: 'var(--Light-Gray)',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '20px',
  color: 'var(--Interviewer-Lighter-Black)',
}));

const StyledGroupBox = styled(Box)(() => ({
  width: '100%',
  boxSizing: 'border-box',
}));

export type Technology = {
  id: string;
  name: string;
  description: string;
  updatedOnUtc: string;
  icon?: React.ReactNode;
};

export type TechnologyListProps = {
  groupName: string
  technologies: Technology[];
};

const TechnologyList: React.FC<TechnologyListProps> = ({ groupName,technologies }) => {
  const navigate = useNavigate();
  const [titleOfGroup, setTitleOfGroup] = useState<string>('');

  useEffect(() => {
    const groupNameStr = String(groupName);
    
    switch(groupNameStr) {
      case '3':
        setTitleOfGroup('Web');
        break;
      case '2':
        setTitleOfGroup('Desktop');
        break;
      case '1':
        setTitleOfGroup('Mobile');
        break;
      default:
        setTitleOfGroup('Unknown');
        break;
    }
  }, [groupName])

  if (!technologies || technologies.length === 0) {
    return (
      <Box sx={{paddingBottom: '30px'}}>
        <NoData />
      </Box>
    );
  }

  return (
    <StyledGroupBox>
      <Typography variant="h2" sx={{ paddingBottom: '24px' }}>
        {titleOfGroup}
      </Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, gap: '24px' }}>
        {technologies.map((tech, key) => {
        // helper function for formatting
        const formatDate = (rawDate: string) => {
          if (!rawDate || rawDate.startsWith("0001-01-01")) return "N/A";
          const dateObj = new Date(rawDate);
          return `${dateObj.getMonth() + 1}/${dateObj.getDate()}/${dateObj.getFullYear()}`;
        };

        return (
          <Box key={key} sx={{ display: 'flex' }}>
            <StyledCard
              onClick={() => {
                navigate({ to: '/job-description', search: { technologyId: tech.id } });
              }}
              style={{ height: '100%', flex: 1, display: 'flex', flexDirection: 'column' }}
            >
              <CardHeader
                sx={{ padding: '0px' }}
                avatar={tech.icon}
                action={<StyledQuestionButton>0 questions available</StyledQuestionButton>}
              />
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                  flex: 1,
                  paddingTop: '24px',
                }}
              >
                <Typography variant="h2">{tech.name}</Typography>
                <Typography variant="h4">{tech.description}</Typography>
                <Typography variant="h5" sx={{ marginTop: '8px' }}>
                  Last Updated {formatDate(tech.updatedOnUtc)}
                </Typography>
              </Box>
            </StyledCard>
          </Box>
        );
      })}

      </Box>
    </StyledGroupBox>
  );
};

export default TechnologyList; 